'use client';
import SingleVs from '@/components/Vs/singleVs';

export default function SingleVsClient() {
  return <SingleVs />;
}
